import { render, staticRenderFns } from "./ArtistPageAccomodation.vue?vue&type=template&id=7631b328&"
import script from "./ArtistPageAccomodation.vue?vue&type=script&lang=js&"
export * from "./ArtistPageAccomodation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports